import { Link, useParams } from 'react-router-dom';

import { Badge, StatusDot } from '@/components/atoms';
import { useExecution } from '@/hooks/useWorkflows';

import styles from './ExecutionDetail.module.css';

export function ExecutionDetail() {
  const params = useParams<{ id: string; execId: string }>();
  const { data: execution, isLoading, error } = useExecution(params.execId);

  if (isLoading) return <p>A carregar…</p>;
  if (error) return <p>Erro: {String(error)}</p>;
  if (!execution) return null;

  return (
    <section className={styles.root}>
      <header className={styles.head}>
        <Link to={`/workflows/${params.id}`} className={styles.back}>
          ← Workflow
        </Link>
        <h1 className={styles.title}>Execução #{execution.id}</h1>
        <Badge
          tone={execution.status === 'success' ? 'ok' : execution.status === 'error' ? 'crit' : 'warn'}
          size="sm"
        >
          {execution.status}
        </Badge>
      </header>

      <div className={styles.meta}>
        <span>Início: {new Date(execution.started_at).toLocaleString('pt-BR')}</span>
        {execution.finished_at && (
          <span>Fim: {new Date(execution.finished_at).toLocaleString('pt-BR')}</span>
        )}
        {execution.duration_ms !== null && (
          <span>Duração: {(execution.duration_ms / 1000).toFixed(2)}s</span>
        )}
        {execution.mode && <span>Modo: {execution.mode}</span>}
      </div>

      <h2 className={styles.sectionTitle}>
        Timeline ({execution.nodes.length} {execution.nodes.length === 1 ? 'nó' : 'nós'})
      </h2>

      {execution.nodes.length === 0 && (
        <p className={styles.muted}>Sem dados de nó (execução em curso ou sem includeData).</p>
      )}

      <ul className={styles.nodeList}>
        {execution.nodes.map((node, idx) => (
          <li key={idx} className={styles.nodeRow}>
            <StatusDot state={node.status === 'error' ? 'crit' : 'ok'} />
            <div className={styles.nodeBody}>
              <div className={styles.nodeTitle}>{node.name}</div>
              <div className={styles.nodeMeta}>
                {node.duration_ms !== null && (
                  <span>{(node.duration_ms / 1000).toFixed(2)}s</span>
                )}
                {node.items_count !== null && <span>{node.items_count} items</span>}
              </div>
              {node.error && <div className={styles.nodeError}>{node.error}</div>}
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
